export interface IActivityLog {
    actionType: ActionType;
    actionTypeName?: string;
    timeStamp: string;
    userName: string | null;
    failureReason: string | null;
    entryData: string;
}

export interface IActionFilter {
    id: number;
    name: string;
    subFilters: IActionFilter[] | null;
}

export interface ITenantFeatureEntry {
    TenantFeatureName: string;
}

export type ActivityLogPagination = {
    items: IActivityLog[];
    pageIndex: number;
    totalCount: number;
};

export enum ActionType {
    DmlCreate = 0,
    DmlUpdate = 1,
    DmlDelete = 2,

    SendingEmail = 3,
    CreatingMailbox = 10,
    EditingMailbox = 12,

    SwitchingTenantFeature = 4,
    RetryFailedStep = 5,
    TerminateTenantFeature = 11,

    Enroll = 6,

    DeletingEnroll = 7,
    DeletingTenant = 8,

    RenewSearchIndex = 9,
}
